import React, { useState } from 'react';
import { Upload, Button, List, Typography, message, Spin, Popconfirm } from 'antd';
import { UploadOutlined, FileOutlined, DownloadOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { startCargaDocumento, startEliminarDocumento, startGetFile } from '../../../context/actions/reembolsosActions';

const { Text } = Typography;

export default function Documentos({ data, onReload }) {
  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);
  const [downloading, setDownloading] = useState(null);
  const [deleting, setDeleting] = useState(null);

  const documentos = data?.documentos ?? [];

  const handleUpload = async (file) => {
    setUploading(true);
    try {
      await dispatch(startCargaDocumento(data.reembolsoID, file));
      message.success('Documento cargado correctamente');
      if (onReload) onReload();
    } catch {
      message.error('Error al cargar el documento');
    } finally {
      setUploading(false);
    }
    return false;
  };

  const handleDownload = async (doc) => {
    setDownloading(doc.reembolsoDocumentoID);
    try {
      const blob = await dispatch(startGetFile(doc.reembolsoDocumentoID));
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = doc.nombreFile;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      message.error('Error al descargar el documento');
    } finally {
      setDownloading(null);
    }
  };

  const handleDelete = async (doc) => {
    setDeleting(doc.reembolsoDocumentoID)
    try {
      await dispatch(startEliminarDocumento(doc.reembolsoDocumentoID))
      message.success('Documento eliminado correctamente')
      if (onReload) onReload()
    } catch {
      message.error('Error al eliminar documento')
    } finally {
      setDeleting(null);
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Upload beforeUpload={(file) => { handleUpload(file); return false; }} showUploadList={false}>
        <Button icon={<UploadOutlined />} loading={uploading} block>
          Cargar documento
        </Button>
      </Upload>

      {documentos.length === 0 ? (
        <Text type="secondary">Sin documentos</Text>
      ) : (
        <List
          size="small"
          dataSource={documentos}
          renderItem={(doc) => {
            console.log('doc:', doc)
            return (
              <List.Item
                actions={[
                  <Button
                    key="dl"
                    type="link"
                    size="small"
                    icon={downloading === doc.reembolsoDocumentoID ? <Spin size="small" /> : <DownloadOutlined />}
                    onClick={() => handleDownload(doc)}
                    disabled={!!downloading}
                  />,
                <Popconfirm
                title="¿Eliminar este documento?"
                onConfirm={() => handleDelete(doc)}
                okText="Si"
                CancelText="No"
                >
                  <Button
                  key="del"
                  type="link"
                  size="small"
                  danger
                  icon={deleting === doc.reembolsoDocumentoID ? <Spin size="small" /> : <DeleteOutlined />}
                  disabled={!!deleting || !!downloading}
                  />
                </Popconfirm>
                ]}
                >
                <List.Item.Meta
                  avatar={<FileOutlined />}
                  title={<Text ellipsis style={{ maxWidth: 140 }}>{doc.nombreFile}</Text>}
                />
              </List.Item>
            )
          }}
        />
      )}
    </div>
  );
}
